import React, { Component } from "react";
import { connect } from "react-redux";
import { throttle } from "lodash";
import { getPointerTarget, getTransform } from "./hotspot";

import {
  setDropdownPrediction,
  setPredictionAllHeights,
} from "./store/actions";

import "./styles.scss";

import gelPrediction from "./img/gel-prediction-46.svg";
import gelPredictionUkrainian from "./img/gel-prediction-46-uk.svg";
import lane1 from "./img/lane-1.svg";
import lane2 from "./img/lane-2.svg";
import lane3 from "./img/lane-3.svg";
import lane4 from "./img/lane-4.svg";
import lane5 from "./img/lane-5.svg";

// solution tubes
import gkmin from "./img/solution-gkmin.svg";
import gamin from "./img/solution-gamin.svg";
import gkplus from "./img/solution-gkplus.svg";
import gaplus from "./img/solution-gaplus.svg";
import glig from "./img/solution-glig.svg";
import gkminSelected from "./img/solution-gkmin-dragged.svg";
import gaminSelected from "./img/solution-gamin-dragged.svg";
import gkplusSelected from "./img/solution-gkplus-dragged.svg";
import gaplusSelected from "./img/solution-gaplus-dragged.svg";
import gligSelected from "./img/solution-glig-dragged.svg";
import emptyTube from "./img/solution-empty.svg";

import { fetchTranslations } from "./locales/config";
import { TranslationsProvider } from "@learningblocks/simulations/shared-components";

import { injectIntl, FormattedMessage } from "react-intl";

const images = {
  gkmin: gkmin,
  gamin: gamin,
  gkplus: gkplus,
  gaplus: gaplus,
  glig: glig,
  "gkmin Selected": gkminSelected,
  "gamin Selected": gaminSelected,
  "gkplus Selected": gkplusSelected,
  "gaplus Selected": gaplusSelected,
  "glig Selected": gligSelected,
  emptyTube: emptyTube,
};

class Predictions46 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dragged: null,
      components: [],
      y1: this.extractHeights(1),
      y2: this.extractHeights(2),
      y3: this.extractHeights(3),
      y4: this.extractHeights(4),
      y5: this.extractHeights(5),
      recombinants: [
        {
          id: 0,
          title: "754 bp",
          selected: false,
          key: "recombinant",
        },
        {
          id: 1,
          title: "1184 bp",
          selected: false,
          key: "recombinant",
        },
        {
          id: 2,
          title: "1614 bp",
          selected: false,
          key: "recombinant",
        },
        {
          id: 3,
          title: "pARA 4872 bp",
          selected: false,
          key: "recombinant",
        },
        {
          id: 4,
          title: "5082 bp",
          selected: false,
          key: "recombinant",
        },
        {
          id: 5,
          title: "pARA-R 5302 bp",
          selected: false,
          key: "recombinant",
        },
        {
          id: 6,
          title: "pKAN-R 5512 bp",
          selected: false,
          key: "recombinant",
        },
        {
          id: 7,
          title: "8990 bp",
          selected: false,
          key: "recombinant",
        },
        {
          id: 8,
          title: "9200 bp",
          selected: false,
          key: "recombinant",
        },
        {
          id: 9,
          title: "9410 bp",
          selected: false,
          key: "recombinant",
        },
      ],
      open: false,
      headerTitle: this.props.title,
      renderLanes: {
        lane1: true,
        lane2: true,
        lane3: true,
        lane4: true,
        lane5: true,
      },
      gelHoleStyles: {
        lane1: "gelHole0",
        lane2: "gelHole0",
        lane3: "gelHole0",
        lane4: "gelHole0",
        lane5: "gelHole0",
      },
    };
  }

  extractHeights = (lane) => {
    const res = [];
    for (let i = 0; i < this.props.bandData["lane" + (lane + 1)].length; i++) {
      res.push(this.props.bandData["lane" + (lane + 1)][i].height);
    }
    return res;
  };

  onDragStart = (e) => {
    let dragImage = document.getElementById("dragImage");

    if (dragImage == null) {
      dragImage = document.createElement("img");
      dragImage.id = "dragImage";
      dragImage.src =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8BQDwAEhQGAhKmMIQAAAABJRU5ErkJggg==";
      document.body.appendChild(dragImage);
    }
    dragImage.style.position = "absolute";
    dragImage.style.top = 0;
    dragImage.style.left = 0;

    const testVar = window.DataTransfer || window.Clipboard; // Clipboard is for Chrome
    if ("setDragImage" in testVar.prototype) {
      e.dataTransfer.setDragImage(dragImage, 0, 0);
    }
    if ("setData" in testVar.prototype) {
      e.dataTransfer.setData("text/plain", "");
    }

    const target = getPointerTarget(e, e.target.childNodes);

    if (typeof target !== "undefined") {
      if (target.id !== undefined) {
        const lane = target.id.split("_")[1];

        document.getElementById(target.id).focus();

        this.setState({
          ["y" + lane + "last"]: e.clientY,
          dragged: typeof target !== "undefined" ? target : null,
        });
      }
    }

    return false;
  };

  drag = throttle((target, clientX, clientY) => {
    if (target && target.id.includes("band")) {
      const transform = getTransform(target);
      const lane = target.id.split("_")[1];
      const band = target.id.split("_")[2];

      if (lane && band) {
        const iYPos = parseFloat(transform.translateY);
        let newY = clientY + iYPos - this.state["y" + lane + "last"];

        if (newY > 630) {
          newY = 630;
        }
        if (newY >= 20) {
          const updateY = this.state["y" + lane];

          updateY[band] = newY;
          console.log(updateY);
          this.setState({
            ["y" + lane]: updateY,
            ["y" + lane + "last"]: clientY,
          });
        }
      }
    }
  }, 20);

  onDragOver = (e) => {
    e.preventDefault();
    this.drag(this.state.dragged, e.clientX, e.clientY);
  };

  onDragEnd = (e) => {
    e.preventDefault();

    const heights = {
      lane1: [],
      lane2: this.state.y1,
      lane3: this.state.y2,
      lane4: this.state.y3,
      lane5: this.state.y4,
      lane6: this.state.y5,
    };

    this.props.setPredictionAllHeights({
      id: 1,
      heights: heights,
    });
  };

  toggleDropdown = () => {
    this.setState({
      open: !this.state.open,
    });
  };

  selectChoice = (item) => {
    this.setState({
      dropDownChoice: item.title,
      open: false,
    });

    this.props.setDropdownPrediction({
      id: 1,
      choice: item.title,
      choiceId: item.id,
    });
  };

  getDropDownText = () => {
    if (this.props.dropDownChoice === "") {
      return this.props.intl.formatMessage({
        id: "Select the plasmid which you think is correct from the list",
        defaultMessage:
          "Select the plasmid which you think is correct from the list",
        description: "",
      });
    } else {
      return this.props.dropDownChoiceId + 1;
    }
  };

  generateDNABand = () => {
    return this.getImage("gA+");
  };

  getTubeImg = (type) => {
    if (type === undefined) {
      return (
        <img
          alt={this.props.intl.formatMessage({
            id: "not found",
            defaultMessage: "not found",
            description: "",
          })}
        />
      );
    } else {
      const modType = type
        .replace("-", "min")
        .replace("+", "plus")
        .toLowerCase();

      return <img src={images[modType]} aria-hidden="true" alt={type} />;
    }
  };

  setBandsVisibile = (lane) => {
    const oldLanes = this.state.renderLanes;
    //toggles true/false
    oldLanes["lane" + lane] = !oldLanes["lane" + lane];
    this.setState({
      renderLanes: oldLanes,
    });
  };

  renderBands = (lane) => {
    const data = this.props.bandData;

    if (this.props.lanesVisible["lane" + lane]) {
      const lanes = ["", "gK−", "gK+", "gA−", "gA+", "gLIG"];

      const bands = [];
      for (let i = 0; i < data["lane" + (lane + 1)].length; i++) {
        const bandData = data["lane" + (lane + 1)][i];

        bands.push(
          <div
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "ArrowUp") {
                this.onMoveUp(e, lane + 1, i);
              } else if (e.key === "ArrowDown") {
                this.onMoveDown(e, lane + 1, i);
              }
            }}
            id={"band_" + lane + "_" + i}
            key={(i + 1) * lane}
            className="gelBand"
            style={{
              transform: "translate(0, " + this.state["y" + lane][i] + "px)",
            }}
            aria-label={
              lanes[lane].replace("−", " minus").replace("+", " plus") +
              " lane " +
              bandData.label +
              " band"
            }
          >
            {bandData.label}
          </div>
        );
      }
      return bands;
    } else {
      return "";
    }
  };

  //Keyboard controls for bands
  onMoveUp = (e, lane, band) => {
    e.preventDefault();

    const heights = {
      lane1: [],
      lane2: this.state.y1,
      lane3: this.state.y2,
      lane4: this.state.y3,
      lane5: this.state.y4,
      lane6: this.state.y5,
    };

    if (heights["lane" + lane][band] - 10 < 20) {
      heights["lane" + lane][band] = 20;
    } else {
      heights["lane" + lane][band] -= 10;
    }

    this.props.setPredictionAllHeights({
      id: 1,
      heights: heights,
    });
  };

  onMoveDown = (e, lane, band) => {
    e.preventDefault();

    const heights = {
      lane1: [],
      lane2: this.state.y1,
      lane3: this.state.y2,
      lane4: this.state.y3,
      lane5: this.state.y4,
      lane6: this.state.y5,
    };

    if (heights["lane" + lane][band] + 10 > 630) {
      heights["lane" + lane][band] = 630;
    } else {
      heights["lane" + lane][band] += 10;
    }

    this.props.setPredictionAllHeights({
      id: 1,
      heights: heights,
    });
  };

  gelHoleClass = () => {
    return "gelHole2";
  };

  render() {
    return (
      <div className="Predictions">
        <div className="">
          <div className="predictions-question-container">
            <h5
              style={{
                margin: "0px",
                padding: "5px 0px 15px",
                fontSize: "18px",
                fontFamily: "'Bio Sans', Arial, sans-serif",
              }}
            >
              <FormattedMessage
                id="Here are the DNA pieces found within each tube."
                defaultMessage="Here are the DNA pieces found within each tube."
                description=""
              />
              {""}
            </h5>
            <div className="section-1">
              <img
                width="100%"
                src={
                  require(`./img/translated-imgs/predictions-1-en.svg`).default
                  // require(`./img/translated-imgs/predictions-1-${this.props.intl.locale}.svg`)
                  //   .default
                }
                alt=""
              />
              <div
                className="imgOverlayDiv1"
                aria-label={this.props.intl.formatMessage({
                  id: "gK minus tube contains nondigested pKAN-R plasmids which have 5512 base pairs. The pKAN-R plasmid contains the red fluorescent protein gene, the pBAD promoter region, and the kanamycin resistance gene.",
                  defaultMessage:
                    "gK minus tube contains nondigested pKAN-R plasmids which have 5512 base pairs. The pKAN-R plasmid contains the red fluorescent protein gene, the pBAD promoter region, and the kanamycin resistance gene.",
                  description: "",
                })}
              ></div>
              <div
                className="imgOverlayDiv2"
                aria-label={this.props.intl.formatMessage({
                  id: "gA minus tube contains nondigested pARA plasmids which have 4872 base pairs. The pARA plasmid contains an ori site (the origin of replication), the araC activator protein, and the ampicillin resistance gene.",
                  defaultMessage:
                    "gA minus tube contains nondigested pARA plasmids which have 4872 base pairs. The pARA plasmid contains an ori site (the origin of replication), the araC activator protein, and the ampicillin resistance gene.",
                  description: "",
                })}
              ></div>
              <div
                className="imgOverlayDiv3"
                aria-label={this.props.intl.formatMessage({
                  id: "gK plus tube contains digested pKAN-R digest fragments. The first fragment contains the red fluorescent protein gene and pBAD promoter region. The second fragment contains the kanamycin resistance gene.",
                  defaultMessage:
                    "gK plus tube contains digested pKAN-R digest fragments. The first fragment contains the red fluorescent protein gene and pBAD promoter region. The second fragment contains the kanamycin resistance gene.",
                  description: "",
                })}
              ></div>
              <div
                className="imgOverlayDiv4"
                aria-label={this.props.intl.formatMessage({
                  id: "gA plus tube contains digested pARA digest fragments. The first fragment contains no relevant genes for this experiment. The second fragment contains an ori site (the origin of replication), the araC activator protein, and the ampicillin resistance gene.",
                  defaultMessage:
                    "gA plus tube contains digested pARA digest fragments. The first fragment contains no relevant genes for this experiment. The second fragment contains an ori site (the origin of replication), the araC activator protein, and the ampicillin resistance gene.",
                  description: "",
                })}
              ></div>
            </div>

            <div className="section-2">
              <img
                width="100%"
                src={
                  require(`./img/translated-imgs/Predictions-2-en.svg`).default
                  // require(`./img/translated-imgs/Predictions-2-${this.props.intl.locale}.svg`)
                  //   .default
                }
                alt={this.props.intl.formatMessage({
                  id: "Shown is a tube labeled gLIG and ten plasmids that may be present inside it. Each plasmid is indicated by a circle, with genes represented within the plasmid circle by the colors red, green, black, light blue, dark blue, and yellow. Each of the ten plasmids have a different combination of genes present.",
                  defaultMessage:
                    "Shown is a tube labeled gLIG and ten plasmids that may be present inside it. Each plasmid is indicated by a circle, with genes represented within the plasmid circle by the colors red, green, black, light blue, dark blue, and yellow. Each of the ten plasmids have a different combination of genes present.",
                  description: "",
                })}
              />
            </div>

            <div className="component-select">
              <h5
                style={{
                  margin: "0px",
                  padding: "5px 0px 15px",
                  fontSize: "18px",
                  fontFamily: "'Bio Sans', Arial, sans-serif",
                }}
              >
                <FormattedMessage
                  id="4. What plasmid in the gLIG tube is the one we are looking for?"
                  defaultMessage="4. What plasmid in the gLIG tube is the one we are looking for?"
                  description=""
                />
              </h5>

              <div className="dropdown">
                <div
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      this.toggleDropdown(e);
                    }
                  }}
                  onClick={this.toggleDropdown}
                  className="dropdown__header"
                >
                  <div
                    style={{
                      color:
                        this.props.dropDownChoice === ""
                          ? "#4d7c9a"
                          : "#003e6b",
                    }}
                  >
                    {this.getDropDownText()}
                  </div>
                  <div className="down-arrow" />
                </div>
                {this.state.open && (
                  <ul className="dropdown__items">
                    {this.state.recombinants.map((item) => (
                      <li
                        role="option"
                        aria-selected={item.id + 1}
                        tabIndex={0}
                        key={item.title}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            this.selectChoice(item);
                          }
                        }}
                        onClick={() => {
                          this.selectChoice(item);
                        }}
                        className="dropdown__items--choice"
                      >
                        {item.id + 1}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
            <p className="description">
              <FormattedMessage
                id="Predict the bands you expect to see when each of the samples shown above is separated by gel electrophoresis. Select each of the tubes to generate and drag bands on the gel to the position you expect them to migrate based on their size and configuration. For the gLIG lane, you can assume that the possible plasmids are all behaving like linear DNA fragments when they migrate through the gel."
                defaultMessage="Predict the bands you expect to see when each of the samples shown above is separated by gel electrophoresis. Select each of the tubes to generate and drag bands on the gel to the position you expect them to migrate based on their size and configuration. For the gLIG lane, you can assume that the possible plasmids are all behaving like linear DNA fragments when they migrate through the gel."
                description=""
              />
            </p>

            <div className="gel-container">
              <div className="description">
                <h5 className="header" style={{ margin: "0", padding: "0px" }}>
                  5. {"Bands in gel"}
                </h5>
                <p className="sub-header">
                  <FormattedMessage
                    id="Drag the DNA bands on the gel below to the position you expect them to migrate through the gel."
                    defaultMessage="Drag the DNA bands on the gel below to the position you expect them to migrate through the gel."
                    description=""
                  />
                </p>

                <div className="" />
              </div>

              <div className="lane-legend">
                <div className="lane-legend__type" id="gkmin">
                  {this.getTubeImg("gK-")}
                  <span
                    aria-label={"gK minus"}
                    className={"lane-legend__type--label"}
                  >
                    {"gK−"}
                  </span>
                </div>

                <div className="lane-legend__type" id="gkplus">
                  {this.getTubeImg("gK+")}

                  <span
                    aria-label={"gK plus"}
                    className={"lane-legend__type--label"}
                  >
                    {"gK+"}
                  </span>
                </div>

                <div className="lane-legend__type" id="gamin">
                  {this.getTubeImg("gA-")}
                  <span
                    aria-label={this.props.intl.formatMessage({
                      id: "gA minus",
                      defaultMessage: "gA minus",
                      description: "",
                    })}
                    className={"lane-legend__type--label"}
                  >
                    {"gA−"}
                  </span>
                </div>

                <div className="lane-legend__type" id="gaplus">
                  {this.getTubeImg("gA+")}
                  <span
                    aria-label={this.props.intl.formatMessage({
                      id: "gA plus",
                      defaultMessage: "gA plus",
                      description: "",
                    })}
                    className={"lane-legend__type--label"}
                  >
                    {"gA+"}
                  </span>
                </div>

                <div className="lane-legend__type" id="glig">
                  {this.getTubeImg("gLIG")}
                  <span
                    aria-label={"gLIG"}
                    className={"lane-legend__type--label"}
                  >
                    {"gLIG"}
                  </span>
                </div>
              </div>

              <div className="Gel-prediction">
                <div className="gel-lane">
                  <div className="gel-lane__slot" id="gel-lane0">
                    <img src={lane1} alt="" />
                  </div>
                  <div
                    className="gel-lane__slot"
                    id="gel-lane1"
                    onDragStart={this.onDragStart}
                    onDragOver={this.onDragOver}
                    onDragEnd={this.onDragEnd}
                  >
                    <div className={this.gelHoleClass(1)}>{"gK-"}</div>
                    <div className={"gelHoleLane1"}>{"M"}</div>
                    <div
                      className={
                        "gelRail" +
                        (this.state.gelHoleStyles.lane1 === "gelHole"
                          ? " highlighted"
                          : "")
                      }
                      draggable
                    >
                      {this.renderBands(1)}
                    </div>
                    <img
                      src={lane1}
                      alt={this.props.intl.formatMessage({
                        id: "Lane 1 of the agarose gel with DNA ladder. Showing various bands.",
                        defaultMessage:
                          "Lane 1 of the agarose gel with DNA ladder. Showing various bands.",
                        description: "",
                      })}
                    />
                  </div>
                  <div
                    className="gel-lane__slot"
                    id="gel-lane3"
                    onDragStart={this.onDragStart}
                    onDragOver={this.onDragOver}
                    onDragEnd={this.onDragEnd}
                  >
                    <div className={this.gelHoleClass(2)}>{"gK+"}</div>
                    <div
                      className={
                        "gelRail" +
                        (this.state.gelHoleStyles.lane2 === "gelHole"
                          ? " highlighted"
                          : "")
                      }
                      draggable
                    >
                      {this.renderBands(2)}
                    </div>
                    <img
                      src={lane3}
                      alt={this.props.intl.formatMessage({
                        id: "Lane 2 of the agarose gel with gK Plus solution. Showing two bands.",
                        defaultMessage:
                          "Lane 2 of the agarose gel with gK Plus solution. Showing two bands.",
                        description: "",
                      })}
                    />
                  </div>
                  <div
                    className="gel-lane__slot"
                    id="gel-lane2"
                    onDragStart={this.onDragStart}
                    onDragOver={this.onDragOver}
                    onDragEnd={this.onDragEnd}
                  >
                    <div className={this.gelHoleClass(3)}>{"gA-"}</div>
                    <div
                      className={
                        "gelRail" +
                        (this.state.gelHoleStyles.lane3 === "gelHole"
                          ? " highlighted"
                          : "")
                      }
                      draggable
                    >
                      {this.renderBands(3)}
                    </div>
                    <img
                      src={lane2}
                      alt={this.props.intl.formatMessage({
                        id: "Lane 3 of the agarose gel with gK minus solution. Showing three bands.",
                        defaultMessage:
                          "Lane 3 of the agarose gel with gK minus solution. Showing three bands.",
                        description: "",
                      })}
                    />
                  </div>
                  <div
                    className="gel-lane__slot"
                    id="gel-lane4"
                    onDragStart={this.onDragStart}
                    onDragOver={this.onDragOver}
                    onDragEnd={this.onDragEnd}
                  >
                    <div className={this.gelHoleClass(4)}>{"gA+"}</div>
                    <div
                      className={
                        "gelRail" +
                        (this.state.gelHoleStyles.lane4 === "gelHole"
                          ? " highlighted"
                          : "")
                      }
                      draggable
                    >
                      {this.renderBands(4)}
                    </div>
                    <img
                      src={lane4}
                      alt={this.props.intl.formatMessage({
                        id: "Lane 4 of the agarose gel with gA minus solution. Showing three bands.",
                        defaultMessage:
                          "Lane 4 of the agarose gel with gA minus solution. Showing three bands.",
                        description: "",
                      })}
                    />
                  </div>
                  <div
                    className="gel-lane__slot"
                    id="gel-lane5"
                    onDragStart={this.onDragStart}
                    onDragOver={this.onDragOver}
                    onDragEnd={this.onDragEnd}
                  >
                    <div className={this.gelHoleClass(5)}>{"gLIG"}</div>
                    <div
                      className={
                        "gelRail" +
                        (this.state.gelHoleStyles.lane5 === "gelHole"
                          ? " highlighted"
                          : "")
                      }
                      draggable
                    >
                      {this.renderBands(5)}
                    </div>
                    <img
                      src={lane5}
                      alt={this.props.intl.formatMessage({
                        id: "Lane 5 of the agarose gel with gA plus solution. Showing two bands.",
                        defaultMessage:
                          "Lane 5 of the agarose gel with gA plus solution. Showing two bands.",
                        description: "",
                      })}
                    />
                  </div>
                </div>

                <img
                  alt=""
                  role="presentation"
                  onKeyDown={(e) => {
                    if (e.key === "ArrowUp") this.moveUp();
                    else if (e.key === "ArrowDown") this.moveDown();
                  }}
                  className="prediction-bg"
                  style={{ pointerEvents: "none" }}
                  src={
                    this.props.intl.locale === "uk"
                      ? gelPredictionUkrainian
                      : gelPrediction
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    bandData: state.predictions,
    dropDownChoice: state.predictions.dropDownChoice,
    dropDownChoiceId: state.predictions.dropDownChoiceId,
    lanesVisible: state.predictions.lanesVisible,
  };
};

const ComponentWithIntl = injectIntl(Predictions46);

export default connect(mapStateToProps, {
  setDropdownPrediction,
  setPredictionAllHeights,
})((props) => (
  <TranslationsProvider fetchTranslations={fetchTranslations}>
    <ComponentWithIntl {...props} />
  </TranslationsProvider>
));
